import { Route, Routes } from "react-router-dom"
import { PageNotFound } from "../PageNotFound"

export const OcxSubdomain = () => {
    return (
        <Routes>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    )
}